import type { HouseholdInsightsApiResponse } from '../apiTypes.ts';
import { mockHouseholdInsightsResponse } from '../mocks/mockHouseholdInsightsResponse.ts';

export type HouseholdInsightsQueryResult = {
  response: HouseholdInsightsApiResponse | undefined;
  isLoading: boolean;
};

/**
 * Fetches the raw Household Insights response shared by every chart on the page.
 *
 * TODO: https://openxtechinc.atlassian.net/browse/EXCH-19058 replace the mock with the real request once the endpoint is defined. Tiles call this hook independently,
 * so the request must be deduplicated by the client cache (Apollo / react-query do this per query key).
 * If the transport has no cache, fetch once in a page-level context provider and read it here instead.
 */
export const useHouseholdInsightsQuery = (): HouseholdInsightsQueryResult => ({
  response: mockHouseholdInsightsResponse,
  isLoading: false,
});
